import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetUserQueryVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type GetUserQuery = { __typename?: "query_root" } & {
  app_users_by_pk?: Types.Maybe<
    { __typename?: "app_users" } & Pick<
      Types.App_Users,
      | "id"
      | "name"
      | "is_admin"
      | "last_logged_in"
      | "image_upload_id"
      | "email"
      | "app_tour_completed"
      | "created_at"
      | "phone_number"
    > & {
        organisations: Array<
          { __typename?: "organisation_users" } & {
            organisation: { __typename?: "organisations" } & Pick<
              Types.Organisations,
              "id" | "name"
            >;
          }
        >;
        selected_organisation?: Types.Maybe<
          { __typename?: "organisations" } & Pick<
            Types.Organisations,
            "id" | "name"
          >
        >;
      }
  >;
};

export const GetUserDocument = gql`
  query GetUser($id: String!) {
    app_users_by_pk(id: $id) {
      id
      name
      is_admin
      last_logged_in
      image_upload_id
      email
      app_tour_completed
      created_at
      phone_number
      organisations {
        organisation {
          id
          name
        }
      }
      selected_organisation {
        id
        name
      }
    }
  }
`;

export function useGetUserQuery(
  options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, "query"> = {}
) {
  return Urql.useQuery<GetUserQuery>({ query: GetUserDocument, ...options });
}
